import videojs from "video.js";

declare global {
  interface Window {
    dataLayer: any;
  }
}

// Below line ensures that this script only runs once, even if there are multiple players
if ((<any>window).embeddedVideoScriptHasRun === undefined) {
  (<any>window).embeddedVideoScriptHasRun = true;

  const addGa4Events = (videoPlayerDiv: HTMLElement) => {
    let ga4DataLayer = window.dataLayer;

    let isUserSeeking = false;

    videoPlayerDiv.addEventListener("play", function () {
      setTimeout(function () {
        if (!isUserSeeking) {
          isUserSeeking = false;
          ga4DataLayer.push({
            event: "UXevent",
            eCategory: "video_play",
            eAction: "video_start",
            eLabel: 0,
          });
        }
      });
    });

    videoPlayerDiv.addEventListener("pause", function () {
      setTimeout(function () {
        if (!isUserSeeking) {
          let videoProgress = Math.round(
            (<HTMLVideoElement>videoPlayerDiv).currentTime,
          );
          isUserSeeking = false;
          ga4DataLayer.push({
            event: "UXevent",
            eCategory: "video_play",
            eAction: "video_progress",
            eLabel: videoProgress,
          });
        }
      }, 100);
    });

    videoPlayerDiv.addEventListener("ended", function () {
      let videoProgress = Math.round(
        (<HTMLVideoElement>videoPlayerDiv).currentTime,
      );
      isUserSeeking = false;
      ga4DataLayer.push({
        event: "UXevent",
        eCategory: "video_play",
        eAction: "video_complete",
        eLabel: videoProgress,
      });
      isUserSeeking = false;
    });

    videoPlayerDiv.addEventListener("seeking", function () {
      isUserSeeking = true;
    });
  };

  const setUpVideoPlayer = (
    videoPlayerDiv: HTMLElement,
    thumbnailContainer: HTMLElement | null,
  ) => {
    const videoUrl = <string>videoPlayerDiv.dataset.videoUrl;
    if (videoPlayerDiv.dataset.videoUrl === undefined) return;

    const videoPlayer = videojs(videoPlayerDiv, { controls: true });
    videoPlayer.src({ type: "video/mp4", src: videoUrl });

    videoPlayer.ready(() => {
      if (thumbnailContainer) {
        thumbnailContainer.style.visibility = "visible";

        thumbnailContainer.addEventListener("click", () => {
          thumbnailContainer.style.opacity = "0";
          let analyticsCookie = document.cookie
            .split("; ")
            .filter((row) => row.startsWith("analytics-cookies-accepted="))
            .map((c) => c.split("=")[1])[0];
          if (analyticsCookie) {
            addGa4Events(videoPlayerDiv);
          }

          videoPlayer.play();

          setTimeout(() => {
            thumbnailContainer.style.visibility = "hidden";
          }, 200);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    Array.from(
      document.getElementsByClassName("embedded-video-container"),
    ).forEach((embeddedVideoContainer) => {
      const videoPlayers = embeddedVideoContainer.getElementsByClassName(
        "embedded-video-player",
      );
      const videoThumbnailContainers =
        embeddedVideoContainer.getElementsByClassName(
          "embedded-video-thumbnail",
        );

      if (videoPlayers.length === 0) return;

      setUpVideoPlayer(
        <HTMLElement>videoPlayers[0],
        videoThumbnailContainers.length > 0
          ? <HTMLElement>videoThumbnailContainers[0]
          : null,
      );
    });
  });
}
